function splitIcaoCharacters(text, className = 'char') {
  let html = '';
  for (let i = 0, len = text.length; i < len; i++) {
    html += `<span class="${className}">${text[i]}</span>`;
  }
  return html;
}